import { createMailItemFiles } from 'owa-attachment-file-types';
import { ClientAttachmentId } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import { ComposeViewState } from 'owa-mail-compose-store';
import createAttachments from 'owa-mail-compose-actions/lib/utils/createAttachments';
import {
    infoBarAddHandler,
    infoBarRemoveHandler,
} from 'owa-mail-compose-actions/lib/utils/infoBarHandlers';

export default function addItem(
    viewState: ComposeViewState,
    attachmentName: string,
    itemId: string,
    isInline: boolean
): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        let hasProcessed = false;
        const handler = infoBarAddHandler(viewState);

        const attachmentErrorHandler = (
            messageId: string,
            infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
        ) => {
            handler(messageId, infoBarMessageViewStateCreator);
            if (!hasProcessed) {
                hasProcessed = true;
                reject({ errorType: 'UploadError', id: messageId });
            }
        };

        const onFinish = (attachmentId: ClientAttachmentId) => {
            if (!hasProcessed) {
                hasProcessed = true;
                resolve(attachmentId.Id);
            }
        };

        const file = createMailItemFiles([attachmentName], [itemId]);
        createAttachments(
            file,
            viewState,
            {
                isInline,
                isHiddenInline: false,
                shouldShare: false,
            },
            null /* processInlineImageBeforeUpload */,
            attachmentErrorHandler,
            infoBarRemoveHandler(viewState),
            onFinish
        );
    });
}
